import axios, { AxiosResponse } from 'axios';
import * as utils from './apiUtils';
import { Notification } from '@/models/apis/notification/notificationResponse';

export default {
  index(): Promise<AxiosResponse<Notification[]>> {
    return axios.get(utils.getApiUrl('/notifications'), {
      params: {},
    });
  },
};
